import { useParams } from "react-router-dom";
import OARecordModule from "../components/OARecordModule";

// One route file serving all record modules via URL param -> recType.
const ROUTE_TO_TYPE = {
  "office-work": "office_work", "invoice-data": "invoice", "item-tracking": "item",
  dispatch: "dispatch", transporter: "transporter", installer: "installer",
};

export default function OARecords() {
  const { module } = useParams();
  const recType = ROUTE_TO_TYPE[module];
  if (!recType) return <div className="p-8 text-slate-500">Unknown module.</div>;
  return <OARecordModule key={recType} recType={recType} />;
}
